import styled, { keyframes, css } from "styled-components";

const expandAnimation = (maxHeight) => keyframes`
  from {
    max-height: 0;
  }
  to {
    max-height: ${maxHeight + 300}px;
  }
`;

const collapseAnimation = (maxHeight) => keyframes`
  from {
    max-height: ${maxHeight + 300}px;
  }
  to {
    max-height: 0;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.dataViz.primaryBlue100};
  gap: 10px;
  grid-column: ${({ fullWidth }) => (fullWidth ? "span 2" : "span 1")};
  max-width: ${({ fullWidth }) => (fullWidth ? "100%" : "fit-content")};
  height: fit-content;
  min-height: ${({ wrapperHeight }) => wrapperHeight + 20}px;

  overflow: hidden;
  ${({ expanded, wrapperHeight }) =>
    expanded
      ? css`
          animation: ${expandAnimation(wrapperHeight)} 0.5s forwards linear;
        `
      : css`
          animation: ${collapseAnimation(wrapperHeight)} 0.5s forwards linear 0.5s;
        `}
`;

export const ContentWrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: ${({ childrenHeight }) => childrenHeight + 20}px;
  height: 100%;
  width: 100%;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.dataViz.primaryBlue100};
`;

export const Children = styled.div`
  width: 100%;
`;
